import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel, SimulatorConteinerButton, SimulatorSubSelectOficeLabelBlack
} from './styles';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { SessionContext, AgileSimulatorContext, HabeasDataSenderContext } from '../../../store';
import { Form, FormFooter, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice, handleChangeIdentification } from '../../../helpers/price';
import { getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { Container, ContainerSinMargen, SimulatorSelectOfficeImg, SimulatorSelectOficeLabel, SimulatorSelectOficeLabelBlack } from '../styles';
import SelectOfficeImg from '../../../assets/images/SelectOfficeImg.svg'
import InputPhone from '../../../components/InputPhone';
import { default as HabeasDataSenderTypes } from '../../../store/HabeasDataSender/types';
import { habeasDataSenderSteps } from '../../../helpers/enum';
import { getDominioCorreo, getDominioCorreoConfirmados } from '../../../services/dominioCorreo';
import FormTemplate from "../../../components/FormTemplate";
import { identificationType } from '../../../helpers/enum';
import { getIdentificationTypes } from '../../../services/calculator';
import InputDefaultOnlyText from '../../../components/InputDefaultOnlyText';
import { enviarNotificacionCedulaHabeasData, postGenerateAutorization } from '../../../services/habeasData';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import { useHistory } from 'react-router-dom';
import SearchFieldCategories from '../../../components/SearchFieldCategories';
import ModalAction from '../../../components/ModalAction';

const HabeasDataSenderForm = ({ setActiveStep, setLastStep }) => {
  const { habeasDataSender, setHabeasDataSender } = useContext(HabeasDataSenderContext);
  const history = useHistory();
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [showModalInfoCorreo, setShowModalInfoCorreo] = useState(false);
  const emailValue = useWatch({ control, name: 'email' });
  const dominioValue = useWatch({ control, name: 'dominioCorreoNuevo' });
  const dominioValue2 = useWatch({ control, name: 'dominioCorreoNuevo2' });
  const emailValue2 = useWatch({ control, name: 'email2' });
  const [anotherDominioCorreo, setAnotherDominioCorreo] = useState(false);
  const [showDominioCorreo, setShowDominioCorreo] = useState(false);
  const [dominiosCorreo, setDominiosCorreo] = useState([]);
  const [showDominioCorreo2, setShowDominioCorreo2] = useState(false);
  const [validFormulario, setValidFormulario] = useState(false);
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [showModalNotificacion, setShowModalNotificacion] = useState(false);
  const [messageModalNotificacion, setMessageModalNotificacion] = useState('');
  const [showModalNotificacionError, setShowModalNotificacionError] = useState(false);
  const [dominiosCorreoConfirmados, setDominiosCorreoConfirmados] = useState([]);
  const [filteredDominiosCorreoConfirmados, setFilteredDominiosCorreoConfirmados] = useState([]);
  const [filteredDominiosCorreo, setFilteredDominiosCorreo] = useState([]);
  const [dominioCorreo, setDominioCorreo] = useState('');
  const [messageModalAdvertencia, setMessageModalAdvertencia] = useState('');
  const [showModalAdvertencia, setShowModalAdvertencia] = useState(false);
  const [showModalInfoWarning, setShowModalInfoWarning] = useState(false);
  const [titleWarning, setTitleWarning] = useState('');
  const [messageWarning, setMessageWarning] = useState('');
  const [email, setEmail] = useState('');
  const [email2, setEmail2] = useState('');
  const [celular, setCelular] = useState('');
  const [celular2, setCelular2] = useState('');
  const [celularOculto, setCelularOculto] = useState('');
  const [celularOculto2, setCelularOculto2] = useState('');
  const [errores, setErrores] = useState([]);
  const [showModalCambioAsesor, setShowModalCambioAsesor] = useState(false);
  const [showModalCambioAsesorEnviado, setShowModalCambioAsesorEnviado] = useState(false);

  async function calculateData(dataa) {
    try {
      setIsLoading(true);
      const validarDominio = anotherDominioCorreo ? (fields.dominioCorreoNuevo === fields.dominioCorreoNuevo2) : true;
      let dominioCorreoValido = dominiosCorreo.find(dominio => dominio.nombre === dataa.dominioCorreo);
      let dominioCorreoValido2 = dominiosCorreo.find(dominio => dominio.nombre === dataa.dominioCorreo2);
      if(!anotherDominioCorreo){
        if(!habeasDataSender.clientData.dominioCorreo?.nombre){
          setMessageWarning('Seleccione un dominio de correo electrónico de la lista')
          setShowModalInfoWarning(true);
          setIsLoading(false);
          return;
        }
        if ((!dominioCorreoValido) || (!dominioCorreoValido2)) {
          setMessageWarning('Seleccione un dominio de correo electrónico de la lista')
          setShowModalInfoWarning(true);
          setIsLoading(false);
          return;
        }
        if((dominioCorreoValido?.nombre !== habeasDataSender.clientData.dominioCorreo.nombre) || (dominioCorreoValido2?.nombre !== habeasDataSender.clientData.dominioCorreo.nombre)){
          setMessageWarning('Seleccione un dominio de correo electrónico de la lista')
          setShowModalInfoWarning(true);
          setIsLoading(false);
          return;
        }
        
      }
      
      if (!((email === email2) && validarDominio)) {
        setMessageError('El correo electrónico no coincide')
        setShowModalInfoError(true);
        setIsLoading(false);
        return;
      }
      if (!(celularOculto === celularOculto2)) {
        setMessageError('El celular no coincide')
        setShowModalInfoError(true);
        setIsLoading(false);
        return;
      }
      if (!((fields.email === fields.email2) && validarDominio)) {
        setMessageError('El correo electrónico no coincide')
        setShowModalInfoError(true);
        setIsLoading(false);
        return;
      }
      const req = new FormData();

      req.append('email', anotherDominioCorreo ? email + fields.dominioCorreoNuevo : email + habeasDataSender.clientData.dominioCorreo.nombre);
      req.append('celular', celularOculto.replace(/\s+/g, ''));
      req.append('idAsesor', session.idAsesor);
      req.append('tipoIdentificacion', tipoDocumento.id);
      req.append('identificacion', fields.identificacion.replaceAll('.', ''));
      req.append('primerNombre', fields.primerNombre);
      if (fields.segundoNombre != '') req.append('segundoNombre', fields.segundoNombre);
      req.append('primerApellido', fields.primerApellido);
      if (fields.segundoApellido != '') req.append('segundoApellido', fields.segundoApellido);
      req.append('archivoIdentificacion1', habeasDataSender.identityPhoto[0] ? habeasDataSender.identityPhoto[0] : null);
      req.append('archivoIdentificacion2', habeasDataSender.identityPhoto[1] ? habeasDataSender.identityPhoto[1] : null);
      req.append('jsonResponse', habeasDataSender.jsonResponse ? JSON.stringify(habeasDataSender.jsonResponse) : null)

      const envioHabeasData = await enviarNotificacionCedulaHabeasData(req);

      if(envioHabeasData.data.tipo == 'VALIDACIONES_FALLIDAS_POLITICA'){
        setErrores(envioHabeasData.data.errores[0]);
        setShowModalCambioAsesor(true);
      }else if (envioHabeasData.data.tipo == 'VALIDACIONES_FALLIDAS'){
        setMessageModalNotificacion(envioHabeasData.data.errores);
        setShowModalNotificacionError(true);
        setIsLoading(false);
        return
      }
      

      const statusCode = Number(envioHabeasData.data.statusCode);
      setMessageModalNotificacion(envioHabeasData.data.message);
      if (statusCode === 200) {
        setShowModalNotificacion(true);
      } else if (statusCode === 400) {
        setShowModalNotificacionError(true);
      } else if (statusCode === 201) {
        setShowModalNotificacion(true);
      } else if (statusCode === 202) {
        setShowModalNotificacion(true);
      }

      setActiveStep(habeasDataSenderSteps.CONTACT_FORM)
      setLastStep(habeasDataSenderSteps.IDENTIFICATION_FORM)
      setIsLoading(false);


      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }

  }

  async function initializeStateComponent() {
    try {
      if (habeasDataSender.twoSteps && habeasDataSender.identityPhoto[0] && habeasDataSender.identityPhoto[1]) {
        setShowModalAdvertencia(true);
      }
      const dominiosCorreo = await getDominioCorreo();
      setDominiosCorreo(dominiosCorreo.data);
      const identificationTypes = await getIdentificationTypes();
      setTipoDocumentos(identificationTypes.data);
      const dominiosCorreoConfirmados = await getDominioCorreoConfirmados();
      setDominiosCorreoConfirmados(dominiosCorreoConfirmados.data);
      setIdentificationRadioChecked({ "id": "CC", "nombre": "Cédula de ciudadanía", "label": "CC", "value": "CC" });
      if (habeasDataSender.clientData.email) {
        const formaCorreo = habeasDataSender.clientData.email.split('@');
        habeasDataSender.clientData.email = formaCorreo[0];
        habeasDataSender.clientData.dominioCorreo = '@' + formaCorreo[1];
      }
      const dominioEncontrado = dominiosCorreo.data.find(correo => habeasDataSender.clientData.dominioCorreo === correo.nombre)
      if (dominioEncontrado) {
        setValue('email', habeasDataSender.clientData.email)
        setValue('email2', habeasDataSender.clientData.email)
        setSelectedDominioCorreo(dominioEncontrado)
      }
      setValue('primerNombre', habeasDataSender.clientData.primerNombre)
      setValue('segundoNombre', habeasDataSender.clientData.segundoNombre)
      setValue('primerApellido', habeasDataSender.clientData.primerApellido)
      setValue('segundoApellido', habeasDataSender.clientData.segundoApellido)
      setValue('identificacion', habeasDataSender.clientData.cedula)
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    initializeStateComponent();
  }, [])

  const onChangeEmail = (e) => {
    const inputValue = e.target.value;
    if (/^\*+$/.test(inputValue)) {
    setValue('email', inputValue);
    return;
  }

  const filteredEmail = inputValue.toLowerCase().replace(/[^a-z0-9._-]/g, '');
  setValue('email', filteredEmail);
  };

  const onChangeEmail2 = (e) => {
    const inputValue = e.target.value;
    if (/^\*+$/.test(inputValue)) {
    setValue('email2', inputValue);
    return;
  }

  const filteredEmail = inputValue.toLowerCase().replace(/[^a-z0-9._-]/g, '');
  setValue('email2', filteredEmail);
  };

  const onBlurEmail = (e) => {
    if (/^\*+$/.test(e.target.value)) {
      return;
    }
    setEmail(e.target.value.toLowerCase());
    const filteredEmail = e.target.value.replace(/./g, "*");
    setValue('email', filteredEmail);
  };

  const onClickEmail = (e) => {
    setValue('email', email);
  };

  const onClickEmail2 = (e) => {
    setValue('email2', email2);
  };

  const onBlurCelular = (e) => {
    if (/^\*+$/.test(e.target.value)) {
      return;
    }
    setCelularOculto(e.target.value);
    setCelular(e.target.value.replace(/\d/g, "*"));
  };

  const onBlurCelular2 = (e) => {
    if (/^\*+$/.test(e.target.value)) {
      return;
    }
    setCelularOculto2(e.target.value);
    setCelular2(e.target.value.replace(/\d/g, "*")); 
  };

  const onChangeCelular = (e) => {
    setCelular(formatPhoneNumber(e.target.value))
    setCelularOculto(formatPhoneNumber(e.target.value))
  };

  const onChangeCelular2 = (e) => {
    setCelular2(formatPhoneNumber(e.target.value))
    setCelularOculto2(formatPhoneNumber(e.target.value))
  };

  const formatPhoneNumber = (value) => {
    // Elimina todo lo que no sea número
    const cleaned = value.replace(/\D/g, '');

    // Formatear con el patrón *** *** ** **
    const formatted = cleaned
      .slice(0, 3) +
      ' ' +
      cleaned.slice(3, 6) +
      ' ' +
      cleaned.slice(6, 8) +
      ' ' +
      cleaned.slice(8, 10);

    return formatted.trim(); // Eliminar posibles espacios extra al final
  };

  const onBlurEmail2 = (e) => {
    if (/^\*+$/.test(e.target.value)) {
      return;
    }
    setEmail2(e.target.value.toLowerCase());
    const filteredEmail = e.target.value.replace(/./g, "*");
    setValue('email2', filteredEmail);
  };

  /*useEffect(() => {
    const lowercaseEmail = emailValue?.toLowerCase().replace(/[^a-z0-9._@-]/g, '')
      .replace(/@/g, (match, offset, str) => str.indexOf('@') === offset ? '@' : '');
    setValue('email', lowercaseEmail);
  }, [emailValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = emailValue2?.toLowerCase().replace(/[^a-z0-9._@-]/g, '')
      .replace(/@/g, (match, offset, str) => str.indexOf('@') === offset ? '@' : '');
    setValue('email2', lowercaseEmail);
  }, [emailValue2, setValue]);*/

  useEffect(() => {
    const lowercaseEmail = dominioValue?.toLowerCase().replace(/[^a-z0-9._@-]/g, '')
      .replace(/@/g, (match, offset, str) => str.indexOf('@') === offset ? '@' : '');
    setValue('dominioCorreoNuevo', lowercaseEmail);
  }, [dominioValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = dominioValue2?.toLowerCase().replace(/[^a-z0-9._@-]/g, '')
      .replace(/@/g, (match, offset, str) => str.indexOf('@') === offset ? '@' : '');
    setValue('dominioCorreoNuevo2', lowercaseEmail);
  }, [dominioValue2, setValue]);

  useEffect(() => {
    setValue("dominioCorreoNuevo", '@')
    setValue("dominioCorreoNuevo2", '@')
  }, [anotherDominioCorreo]);


  const handleCopy = (event) => {
    event.preventDefault();
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  function setSelectedDominioCorreo(dominioCorreo) {
    setValue("dominioCorreo", dominioCorreo?.nombre);
    setValue("dominioCorreo2", dominioCorreo?.nombre);
    setDominioCorreo(dominioCorreo)
    clearErrors("dominioCorreo", {});
    clearErrors("dominioCorreo2", {});
    dominioCorreo?.nombre == 'Agregar otro dominio' ? setAnotherDominioCorreo(true) : setAnotherDominioCorreo(false);
    setHabeasDataSender({
      type: HabeasDataSenderTypes.SET_DOMINIO_CORREO,
      dominioCorreo: dominioCorreo
    })
    setShowDominioCorreo(false);
    setShowDominioCorreo2(false);
  }

  function setIdentificationRadioChecked(radio) {
    setHabeasDataSender({
      type: HabeasDataSenderTypes.SET_IDENTIFICATION_TYPE,
      tipoIdentificacion: radio
    })
    setTipoDocumento(radio)
  }


  function onChangeIdentification(e) {
    var identificacion = undefined;
    /*if (habeasDataSender.clientData.tipoIdentificacion.value === 'CE') {
      identificacion = e.target.value;
    } else {*/
    identificacion = handleChangeIdentification(e.target.value);
    //}
    setValue('identificacion', identificacion);
  }

  function setBackStep() {
    setActiveStep(habeasDataSenderSteps.IDENTIFICATION_FORM);
  }

  function searchInDominios(e) {
    setShowDominioCorreo(true);
    let filtered = dominiosCorreo.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    let filtered2 = dominiosCorreoConfirmados.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDominiosCorreo(filtered);
    setFilteredDominiosCorreoConfirmados(filtered2);
  }

  function searchInDominios2(e) {
    setShowDominioCorreo2(true);
    let filtered = dominiosCorreo.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    let filtered2 = dominiosCorreoConfirmados.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDominiosCorreo(filtered);
    setFilteredDominiosCorreoConfirmados(filtered2);
  }

  async function generateAutorization() {
    try {
      setIsLoading(true);
      setShowModalCambioAsesor(false)
      const req2 = new FormData();
      req2.append('tipoIdentificacion', tipoDocumento.id);
      req2.append('identificacion', fields.identificacion.replaceAll('.', ''));
      req2.append('idAsesor', session.idAsesor);
      req2.append('data', errores);
      const response = await postGenerateAutorization(req2);
      setIsLoading(false);
      setShowModalCambioAsesorEnviado(true);
    } catch (error) {
      setIsLoading(false);
    }
  }

  return (
    <div style={{ padding: '40px', paddingTop: '0px' }}>
      <FormTemplate
        idForm="basic-data-step-page"
        activeStep={habeasDataSender.twoSteps ? "2/2" : "1/1"}
        stepLabel="Datos básicos"
      >
        <Form onSubmit={handleSubmit(calculateData)}>
          <ContainerSinMargen>
            <SimulatorSelectOfficeImg src={SelectOfficeImg}></SimulatorSelectOfficeImg>
            <SimulatorSelectOficeLabel>Autorización de tratamiento de datos personales</SimulatorSelectOficeLabel>
            <SimulatorSelectOficeLabelBlack>Para iniciar el proceso de autorización, por favor envía la notificación a través de WhatsApp
              y correo electrónico. Puedes consultar en el simulador con la cédula del cliente, si ya tiene una autorización de tratamiento de datos.</SimulatorSelectOficeLabelBlack>
            <div style={{ width: "100%" }}>
              <FormRow col="3">
                <Select
                  error={errors.tipoDocumento}
                  setShow={setShowTipoDocumentos}
                  show={showTipoDocumentos}
                  defaultValue={habeasDataSender.clientData.tipoIdentificacion?.nombre}
                  setSelected={setIdentificationRadioChecked}
                  list={tipoDocumentos}
                  placeholder="Seleccionar..."
                  label="Tipo de documento"
                  name="tipoIdentificacion"
                  id="tipoIdentificacion"
                  register={register({ required: "Este dato es obligatorio" })}
                  disabled={habeasDataSender.dataCedula}
                />
                <Controller
                  name="identificacion"
                  control={control}
                  value={habeasDataSender.clientData.identificacion}
                  render={() => (
                    <InputDefault
                      name="identificacion"
                      label="Número de documento de identidad"
                      register={register({
                        required: "Este dato es obligatorio",
                        pattern: {
                          value: /^\d+(\.\d+)*$/,
                          message: "Error en el número, ingresa uno válido",
                        }
                      })}
                      id="identificacion"
                      error={errors.identificacion}
                      maxLength={identificationType.cc.max}
                      minLength={identificationType.ce.min}
                      onChange={onChangeIdentification}
                      readOnly={habeasDataSender.dataCedula}
                    />
                  )}
                />

              </FormRow>
              <FormRow col="3">
                <Controller
                  as={InputDefaultOnlyText}
                  control={control}
                  label="Primer Nombre"
                  name="primerNombre"
                  register={register({ required: "Este dato es obligatorio" })}
                  id="primerNombre"
                  error={errors.primerNombre}
                  value={habeasDataSender.clientData.primerNombre}
                  readOnly={habeasDataSender.dataCedula} />
                <Controller
                  as={InputDefaultOnlyText}
                  control={control}
                  label="Segundo Nombre"
                  name="segundoNombre"
                  register={register}
                  id="segundoNombre"
                  value={habeasDataSender.clientData.segundoNombre}
                  readOnly={habeasDataSender.dataCedula} />
              </FormRow>
              <FormRow col="3">
                <Controller
                  as={InputDefaultOnlyText}
                  control={control}
                  label="Primer Apellido"
                  name="primerApellido"
                  register={register({ required: "Este dato es obligatorio" })}
                  id="primerApellido"
                  error={errors.primerApellido}
                  value={habeasDataSender.clientData.primerApellido}
                  readOnly={habeasDataSender.dataCedula} />
                <Controller
                  as={InputDefaultOnlyText}
                  control={control}
                  label="Segundo Apellido"
                  name="segundoApellido"
                  register={register}
                  id="segundoApellido"
                  value={habeasDataSender.clientData.segundoApellido}
                  readOnly={habeasDataSender.dataCedula} />
              </FormRow>

              <FormRow col="3">
                <InputDefault
                  label="Correo Electrónico"
                  name="email"
                  onChange={onChangeEmail}
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  onBlur={onBlurEmail}
                  autoComplete="off"
                  onClick={onClickEmail}
                  register={register({
                    required: "Este dato es obligatorio",
                    /*pattern: {
                      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "El correo electrónico tiene un formato inválido",
                    },*/
                  })}
                  id="email"
                  error={errors.email}
                  value={email}
                />
                <SearchFieldCategories
                  label="Dominio De Correo Electrónico"
                  name="dominioCorreo"
                  id="dominioCorreo"
                  show={showDominioCorreo}
                  subcategory1={'Dominios sugeridos'}
                  list={filteredDominiosCorreoConfirmados}
                  subcategory2={'Otros dominios'}
                  list2={filteredDominiosCorreo}
                  defaultValue={habeasDataSender.clientData.dominioCorreo?.nombre}
                  selectField={setSelectedDominioCorreo}
                  searchInList={searchInDominios}
                  register={register}
                  placeholder="Buscar..."
                  error={errors.dominioCorreo}
                />
                {/* 
                  <Select
                  error={errors.dominioCorreo}
                  setShow={setShowDominioCorreo}
                  show={showDominioCorreo}
                  defaultValue={habeasDataSender.clientData.dominioCorreo?.nombre}
                  setSelected={setSelectedDominioCorreo}
                  list={dominiosCorreo}
                  placeholder="Seleccionar..."
                  label="Dominio Correo Electrónico"
                  name="dominioCorreo"
                  id="dominioCorreo"
                  register={register({ required: "Este dato es obligatorio" })} />
                */}

                {anotherDominioCorreo &&
                  <Controller
                    as={InputDefault}
                    control={control}
                    label="DOMINIO DE CORREO ELECTRÓNICO"
                    name="dominioCorreoNuevo"
                    onChange={onChangeEmail}
                    onCopy={handleCopy}
                    onPaste={handlePaste}
                    autoComplete="off"
                    register={register({
                      required: "Este dato es obligatorio",
                      pattern: {
                        value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                        message: "El dominio del correo electrónico tiene un formato inválido"
                      }
                    })}
                    id="dominioCorreoNuevo"
                    error={errors.dominioCorreoNuevo}
                    value={habeasDataSender.clientData.dominioCorreoNuevo}
                  />}
              </FormRow>
              <FormRow col="3">
                <InputDefault
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  autoComplete="off"
                  label="Confirmar Correo Electrónico"
                  name="email2"
                  onChange={onChangeEmail2}
                  register={register({
                    required: "Este dato es obligatorio",
                  })}
                  id="email2"
                  error={errors.email}
                  value={email2}
                  onBlur={onBlurEmail2}
                  onClick={onClickEmail2}
                />


                <SearchFieldCategories
                  label="Confirmar DOMINIO DE CORREO ELECTRÓNICO"
                  name="dominioCorreo2"
                  id="dominioCorreo2"
                  show={showDominioCorreo2}
                  subcategory1={'Dominios sugeridos'}
                  list={filteredDominiosCorreoConfirmados}
                  subcategory2={'Otros dominios'}
                  list2={filteredDominiosCorreo}
                  defaultValue={habeasDataSender.clientData.dominioCorreo?.nombre}
                  selectField={setSelectedDominioCorreo}
                  searchInList={searchInDominios2}
                  register={register}
                  placeholder="Buscar..."
                  error={errors.dominioCorreo}
                />
                {/* 
                  <Select
                  error={errors.dominioCorreo}
                  setShow={setShowDominioCorreo2}
                  show={showDominioCorreo2}
                  defaultValue={habeasDataSender.clientData.dominioCorreo?.nombre}
                  setSelected={setSelectedDominioCorreo}
                  list={dominiosCorreo}
                  placeholder="Seleccionar..."
                  label="Confirmar Dominio Correo Electrónico"
                  name="dominioCorreo2"
                  id="dominioCorreo2"
                  register={register({ required: "Este dato es obligatorio" })} />
                */}

                {anotherDominioCorreo &&
                  <Controller
                    as={InputDefault}
                    control={control}
                    onCopy={handleCopy}
                    onPaste={handlePaste}
                    autoComplete="off"
                    label="Confirmar Dominio De Correo Electrónico"
                    name="dominioCorreoNuevo2"
                    onChange={onChangeEmail}
                    register={register({
                      required: "Este dato es obligatorio",
                      pattern: {
                        value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                        message: "El dominio del correo electrónico tiene un formato inválido"
                      }
                    })}
                    id="dominioCorreoNuevo2"
                    error={errors.dominioCorreoNuevo}
                    value={habeasDataSender.clientData.dominioCorreoNuevo}
                  />}
              </FormRow>
              <FormRow col="3">
              <InputPhone
                  label="Celular"
                  name="celular"
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  register={register({
                    required: "Este dato es obligatorio",
                    pattern: {
                      value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                      message: "Error en el número, ingresa uno válido",
                    },
                  })}
                  id="celular"
                  error={errors.celular}
                  mask="999 999 99 99"
                  value={celular}
                  onClick={(e) => setCelular(celularOculto)}
                  onBlur={onBlurCelular}
                  onChange={onChangeCelular}
                   />

                <InputPhone
                  label="Confirmar Celular"
                  name="celular2"
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  register={register({
                    required: "Este dato es obligatorio",
                    /*pattern: {
                      value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                      message: "Error en el número, ingresa uno válido",
                    },*/
                  })}
                  id="celular2"
                  error={errors.celular2}
                  value={celular2}
                  onClick={(e) => setCelular2(celularOculto2)}
                  onBlur={onBlurCelular2}
                  onChange={onChangeCelular2}
                  />
                {/** <InputFileBackGroundImage
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        canAddFile={true}
        //selectedFile={clientRegistration.identityPhoto}
        files={habeasDataSender.clientData.identityPhoto}
        removeFile={removeFile}
        description="Elige dos archivos PNG, JPEG o JPG, o arrasta aqui."
        />*/}
              </FormRow>
              <br></br>
              <SimulatorSubSelectOficeLabelBlack>Estimado cliente, para dar continuidad a su solicitud es necesario que nos autorice el tratamiento de datos personales. Por tal razón, en este momento ExcelCredit le enviará a su WhatsApp y correo electrónico un link para acceder al formato y una vez haga lectura y esté de acuerdo, proceda con la autorización ingresando el código temporal OTP que le llegará en el mismo mensaje.</SimulatorSubSelectOficeLabelBlack>
              <br></br>
              <FormFooter justify="space-between">
                {habeasDataSender.twoSteps && <DefaultLargeButton type="button" onClick={() => setBackStep()}>Volver</DefaultLargeButton>}
                <ClientDataButtoCalculateButton type="submit">Enviar notificación</ClientDataButtoCalculateButton>

              </FormFooter>
            </div>
          </ContainerSinMargen>
          {isLoading && <Loader></Loader>}
        </Form>
        <ModalInfo
          open={showModalInfoError}
          setShowModal={setShowModalInfoError}
          title={titleError}
          description={messageError}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalActionSendIdValidation
          open={showModalNotificacion}
          actionFunctionDownButton={() => history.push('/admin/send-habeas')}
          actionLabelFunctionDownButton="Continuar"
          description={messageModalNotificacion}
          bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
          backgroundIcon={colors.textHyperlink} />
        <ModalActionSendIdValidation
          open={showModalNotificacionError}
          actionFunctionDownButton={() => setShowModalNotificacionError(false)}
          actionLabelFunctionDownButton="Continuar"
          description={messageModalNotificacion}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
          backgroundIcon={colors.bgDanger} />
        <ModalActionSendIdValidation
          open={showModalAdvertencia}
          actionFunctionDownButton={() => setShowModalAdvertencia(false)}
          actionLabelFunctionDownButton="Continuar"
          description='Para asegurarnos de que toda la información en nuestro sistema es correcta, por favor, confirma los datos del cliente.'
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
          backgroundIcon={colors.yellow} />
          <ModalInfo
          open={showModalInfoWarning}
          setShowModal={setShowModalInfoWarning}
          title={titleWarning}
          description={messageWarning}
          backgroundIcon={colors.bgTertiary}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
          <ModalAction
            open={showModalCambioAsesor}
            setShowModal={setShowModalCambioAsesor}
            actionLabelFunctionUpButton='Si, enviar solicitud'
            actionFunctionUpButton={() => generateAutorization()}
            actionLabelFunctionDownButton='Cancelar Solicitud'
            actionFunctionDownButton={() => setShowModalCambioAsesor(false)}
            title={"Estimado asesor "+session.name+","}
            description={<>En este momento no tienes autorización para iniciar la gestión con el cliente. Sin embargo, puedes solicitar un cambio de asesor.
            <br></br>¿Deseas enviar la solicitud de cambio de asesor ahora?</>}
            backgroundIcon={colors.bgDanger}
            bodyIcon={<BsExclamation size={32} color={colors.white} />} />
          <ModalAction
            open={showModalCambioAsesorEnviado}
            setShowModal={setShowModalCambioAsesorEnviado}
            title="Hemos recibido tu solicitud de cambio de asesor."
            description="En las próximas 24 horas, recibirás un correo electrónico con la respuesta a tu solicitud."
            backgroundIcon={colors.textHyperlink}
            bodyIcon={<BsCheck size={32} color={colors.white} />} />
      </FormTemplate>

    </div>
  )
}

export default HabeasDataSenderForm
